import { config } from '../config';
import { HttpServices } from '../Helper';

export const GetAllAwards = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/Award/GetAllAwards`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const GetUserAwards = async (userId, pageIndex, pageSize) => {
  const result = await HttpServices.get(
    `${config.server_address}/CrmDfm/Award/GetUserAwards/${userId}?pageIndex=${pageIndex}&pageSize=${pageSize}`
  )
    .then((data) => data)
    .catch(() => undefined);
  return result;
};

export const CreateAward = async (body) => {
  const result = await HttpServices.post(
    `${config.server_address}/CrmDfm/Award/CreateAward`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const UpdateAward = async (awardId, body) => {
  const result = await HttpServices.put(
    `${config.server_address}/CrmDfm/Award/UpdateAward/${awardId}`,
    body
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};

export const DeleteAward = async (awardId) => {
  const result = await HttpServices.delete(
    `${config.server_address}/CrmDfm/Award/DeleteAward/${awardId}`
  )
    .then((data) => data)
    .catch((error) => error.response);
  return result;
};
